import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

import { ModalService } from 'common/source/services/modal';
import { formatAsDollarsWithoutZeroCents } from 'common/source/utilities/strings';
import { getCallToActionMapping } from 'utilities/paymentsHelper';

const module = angular.module('login-cta', []);

interface LoginCtaController extends angular.IStrictController {
    amountOwed: string;
    close: () => void;
    paymentsSref: string;
    data: LoginCtaOptions;
    copy: string;
    title: string;
    closeText: string;
}

interface LoginCtaOptions {
    policyInfo: CustomerPolicyInfo;
}

module.component('loginCta', {
    template: template,
    bindings: {
        data: '<'
    },
    controller: function(this: LoginCtaController, $stateParams: PolicyStateParams, modalService: ModalService) {
        this.$onInit = () => {
            const policyIndex = $stateParams.policyIndex;
            this.closeText = 'close';
            this.amountOwed = formatAsDollarsWithoutZeroCents(this.data.policyInfo.payment_amount);
            const cta = getCallToActionMapping(this.data.policyInfo);
            if (cta) {
                this.title = cta.header || '';
                this.copy = typeof cta.copy === 'string' ? cta.copy : cta.copy(this.data.policyInfo);
                if (cta.ctaSref) {
                    this.paymentsSref = cta.ctaSref(policyIndex);
                    this.closeText = 'Not now';
                }
            }
        };

        this.close = () => {
            modalService.closeAllDialogs();
        };
    }
});

export { module };
